import { useGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdCategories } from '@fukuri-admins/apis/client/gen/endpoints';

export const useGetStressAssessmentCategories = (
  threeLetterCode: string,
  stressAssessmentId: number,
  options?: Parameters<
    typeof useGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdCategories
  >[2]
) => {
  return useGetApiV1ThreeLetterCodeClientAdminsStressAssessmentsIdCategories(
    threeLetterCode,
    String(stressAssessmentId),
    options
  );
};
